import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import baseApi from "../services/rtkQueryServices/baseApiService";
import { clinicFilterSlice } from "./slices/clinicFilterSlice";
import emailReducer from "./slices/emailSlice";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    email: emailReducer,
    clinicManagement: clinicFilterSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
